export function applyThemeCss({ id = 'dynamic-theme', href, cacheBust }) {
  if (!href) return;
  const elId = id;
  let link = document.getElementById(elId);
  const url = cacheBust ? `${href}${href.includes('?') ? '&' : '?'}v=${cacheBust}` : href;

  if (!link) {
    link = document.createElement('link');
    link.id = elId;
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  } else if (link.href !== url) {
    link.href = url;
  }
}

export function removeThemeCss({ id = 'dynamic-theme' } = {}) {
  const el = document.getElementById(id);
  if (el && el.parentNode) el.parentNode.removeChild(el);
}
